import useForm from '@/compositions/useForm'
import { email } from '@/utils/validations'
import LinkDecorated from '@/components/@ui/LinkDecorated/index'

export default {
  name: 'TransportForm',
  props: {
    removable: Boolean,
  },
  components: {
    LinkDecorated,
  },
  setup() {
    const {
      formData, validate, $errors, getData,
    } = useForm({
      fields: {
        email: { default: '', validations: { email } },
      },
    })

    return {
      formData,
      validate,
      $errors,
      getData,
    }
  },
}
